import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.background};
  padding: 3rem 5%;
  text-align: center;
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  font-style: italic;
`;

const Copyright = styled.p`
  font-size: 0.8rem;
  opacity: 0.6;
  margin-top: 2rem;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Logo>es.cu.ta</Logo>
      <p>A sua plataforma de social listening naturalmente brasileira.</p>
      <Copyright>
        &copy; {new Date().getFullYear()} es.cu.ta. Todos os direitos reservados.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;